<template>
  <div>
    <ClientOnly>
      <div class="relative">
        <swiper-container ref="containerRef" :slides-per-view="slidesPerView">
          <swiper-slide
            v-for="item in carouselList"
            :key="hash(item)"
            class="h-auto p-2.5"
          >
            <slot name="card" :item="item" />
          </swiper-slide>
        </swiper-container>

        <div
          v-if="isShowNavigation"
          class="absolute bottom-0 z-10 flex w-full items-center justify-center"
        >
          <button
            class="flex h-8 w-8 items-center justify-center rounded-full bg-white text-blue-400 shadow-normal shadow-gray-400"
            :class="isBeginning && 'pointer-events-none opacity-50'"
            @click="prev()"
          >
            <IconCaret direction="left" />
          </button>

          <div class="w-[220px]" />

          <button
            class="flex h-8 w-8 items-center justify-center rounded-full bg-white text-blue-400 shadow-normal shadow-gray-400"
            :class="isEnd && 'pointer-events-none opacity-50'"
            @click="next()"
          >
            <IconCaret direction="right" />
          </button>
        </div>
      </div>
    </ClientOnly>

    <!-- For SEO -->
    <ul class="hidden">
      <li v-for="item in carouselList" :key="hash(item)">
        <slot name="card" :item="item" />
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts" generic="T extends {}">
  import hash from 'object-hash';

  interface IProps {
    carouselList?: T[];
    slidesPerView?: number;
  }

  const props = withDefaults(defineProps<IProps>(), {
    carouselList: () => [],
    slidesPerView: 1,
  });

  const containerRef = ref<null>(null);

  const isShowNavigation = computed((): boolean => {
    return props.carouselList.length > props.slidesPerView;
  });

  const { instance, isBeginning, isEnd, next, prev } = useSwiper(containerRef, {
    pagination: {
      type: 'progressbar',
    },
  });

  watch(
    () => props.carouselList,
    async () => {
      await nextTick();
      if (!instance.value) return;
      instance.value.updateSlides();
      instance.value.slideTo(0, 0);
      instance.value.updateSlidesClasses();
    }
  );
</script>

<style lang="scss" scoped>
  swiper-container {
    &::part(pagination) {
      @apply static mx-auto mb-4 mt-12 w-[200px] overflow-hidden rounded-full bg-gray-400;
    }
  }
</style>
